module.exports = __webpack_public_path__ + "static/media/obc-placeholder-thumb.609fad4b.png";